import UtilsString from '@/utils/UtilsString';

export default class ModelArquivoUpload {
  /**
   * @param {File} file
   * @param {XMLHttpRequest} xhr
   */
  constructor(file, xhr) {
    this.id = UtilsString.generateUuid();
    this.size = UtilsString.formatBytes(file.size);
    this.file = file;
    this.name = file.name;
    this.progress = 0;
    this.status = 'pending';
    this.xhr = xhr;
    this._updateCallback = null;
    this.errorMessage = null;

    xhr.upload.addEventListener('progress', (e) => {
      this.progress = Math.round((e.loaded * 100.0) / e.total) || 0;
      if (this._updateCallback) {
        this._updateCallback();
      }
    });
  }

  onUpdate(callback) {
    this._updateCallback = callback;
  }
}
